// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"0c24b34a","328":"3142825f","396":"59bc437d"}[chunkId] + ".chunk.js";
};